<template>
  <v-navigation-drawer
    v-model="isShowForm"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form class="d-flex flex-column" style="height: calc(100% - 64px)">
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ hardware.hardware_serial_number }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ hardware.title_th ? hardware.title_th : '' }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClickClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="px-5 pb-5" style="height: 100%; overflow: auto">
        <div
          v-if="
            hardware.hardware_model &&
            ['vf1000', 'vf1000r', 'vf600'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <v-card
            @click="
              onClickCommand({
                sync_code: 'get_device_info',
                title: 'Get Device Info',
              })
            "
            style="cursor: pointer"
            class="mt-3 pa-2 d-flex justify-space-between"
            outlined
          >
            <div class="d-flex align-center">
              <span class="pa-3 grey lighten-3 rounded">
                <v-icon>mdi-text-box-outline</v-icon>
              </span>
              <div class="ml-2">Get Device Info</div>
            </div>
            <v-icon>mdi-chevron-right</v-icon>
          </v-card>
          <v-card
            @click="
              onClickCommand({
                sync_code: 'get_employee_list',
                title: 'Get Employee List',
              })
            "
            style="cursor: pointer"
            class="mt-3 pa-2 d-flex justify-space-between"
            outlined
          >
            <div class="d-flex align-center">
              <span class="pa-3 grey lighten-3 rounded">
                <v-icon>mdi-text-box-outline</v-icon>
              </span>
              <div class="ml-2">Get Employee List</div>
            </div>
            <v-icon>mdi-chevron-right</v-icon>
          </v-card>
        </div>

        <div
          v-else-if="
            hardware.hardware_model &&
            ['acu81', 'acu01r', 'tat51i'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <v-card
            @click="
              onClickCommand({
                sync_code: 'get_device_info',
                title: 'Get Device Info',
              })
            "
            style="cursor: pointer"
            class="mt-3 pa-2 d-flex justify-space-between"
            outlined
          >
            <div class="d-flex align-center">
              <span class="pa-3 grey lighten-3 rounded">
                <v-icon>mdi-text-box-outline</v-icon>
              </span>
              <div class="ml-2">Get Device Info</div>
            </div>
            <v-icon>mdi-chevron-right</v-icon>
          </v-card>
        </div>
        <div v-else class="pa-5">ไม่มีคำสั่ง</div>
        <!-- <div v-for="command in commands" :key="command.hardware_resource_code">
          <div class="mt-5">{{ command.title_th }}</div>
          <v-card
            @click="onClickCommand(resource)"
            style="cursor: pointer;"
            class="mt-3 pa-2 d-flex justify-space-between"
            outlined
            v-for="resource in command.resources"
            :key="resource.sync_code"
          >
            <div class="d-flex align-center">
              <span class="pa-3 grey lighten-3 rounded">
                <v-icon>mdi-text-box-outline</v-icon>
              </span>
              <div class="ml-2">{{ resource.title_th }}</div>
            </div>
            <v-icon>mdi-chevron-right</v-icon>
          </v-card>
        </div> -->
      </div>
    </v-form>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    isShowForm: {
      type: Boolean,
      required: true,
    },
    hardware: {
      type: Object,
      required: true,
    },
    // commands: {
    //   type: Array,
    //   required: true
    // }
  },

  methods: {
    onClickClose() {
      this.$emit('onClickClose')
    },

    onClickCommand(resource) {
      this.$emit('onClickCommand', resource)
    },
  },
}
</script>
